module.exports = __webpack_public_path__ + "../static/img/salogo2.27dd9e9c.png";